import { render, staticRenderFns } from "./IrrigatorList.vue?vue&type=template&id=15063205&scoped=true&"
import script from "./IrrigatorList.vue?vue&type=script&lang=js&"
export * from "./IrrigatorList.vue?vue&type=script&lang=js&"
import style0 from "./IrrigatorList.vue?vue&type=style&index=0&id=15063205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15063205",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBadge,VCol,VRow,VSimpleTable})
